// extracted by mini-css-extract-plugin
export default {"container":"akeFqO","shadow":"bkeFqO"};